import { hot } from "react-hot-loader/root";

import App from "./app";

export default hot(App);
